export enum GeneralAttributes {
    ari = "Ari Armaturen",
    netilion = "Endress + Hauser",
    krohne = "Krohne",
    bray = "Bray",
    samson = "Samson",
    gea = "Gea",
    wika = "Wika"
}